export default __webpack_public_path__ + "static/media/feedback-scope-improvement.18cf1564.svg";